import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_CustomerListComponent from "../components/_FM_customer/_FM_CustomerListComponent";
import _FM_CustomerFormComponent from "../components/_FM_customer/_FM_CustomerFormComponent";
import _FM_CustomerShowComponent from "../components/_FM_customer/_FM_CustomerShowComponent";
import _FM_FolioShowComponent from "../components/_FM_folio/_FM_FolioShowComponent";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import {Dialog} from "primereact/dialog";
import _FM_FolioDndComponent from "../components/_FM_folio/_FM_FolioDndComponent";
import {Message} from "primereact/message";
import {Button} from "primereact/button";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_CustomerPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  useEffect(() => {
    document.title = t('customers') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/customer')
  }, []);

  return (
    <div className="_FM_CustomerPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/customer"}/>
      <Panel>
        <_FM_CustomerListComponent />
      </Panel>
      <Sidebar position="right" visible={(action === 'update' || action === 'create')} closeOnEscape={true}
               style={{width: '980px'}}
               onHide={() => {
                 navigate('/customer');
               }}>
        <_FM_CustomerFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read' && id} closeOnEscape={true}
               style={{width: '980px'}}
               onHide={() => {
                 navigate('/customer');
               }}>
        <_FM_CustomerShowComponent />
      </Sidebar>
      <Dialog visible={window.App.urlVars().read === 'folio'}
              header={t('customer_folio')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate('/customer/' + action + '/' + id);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_FolioShowComponent customerId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().update === 'folio' || window.App.urlVars().create === 'folio'}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              header={t('customer_folio')}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_FolioFormComponent customerId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().manage === 'folio'}
              header={t('customer_folio')}
              onHide={() => {
                navigate('/customer/' + action + '/' + id);
              }}
              modal={false}
              draggable={false}
              style={{width: '99%'}}>
        <_FM_FolioDndComponent />
      </Dialog>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().create === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptFormComponent />
      </Dialog>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().read === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptShowComponent />
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(_FM_CustomerPage);
